import { environment } from "../config/environment";
import { getFromBackendAPI } from "./api.service";

interface UserFeaturesResponse {
  features: string[];
}

export async function getUserFeatures(): Promise<string[]> {
  const response = await getFromBackendAPI<UserFeaturesResponse>(
    `${environment.api.baseUrl}${environment.api.endpoints.users}/me/features`
  );
  return response.features;
}
